import React from 'react';
import {
    Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, ModalCloseButton,
    Button, VStack, Text, Box, Heading, List, ListItem, ListIcon, Badge, Divider
} from '@chakra-ui/react';
import { CheckCircleIcon, WarningTwoIcon, QuestionOutlineIcon, InfoIcon } from '@chakra-ui/icons';

const formatDate = (dateString) => {
    if (!dateString) return 'N/D';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return 'Data inválida';
    return date.toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' }).replace(',', '');
};

export const DetalhesConferenciaModal = ({ isOpen, onClose, detalhes }) => {
    if (!detalhes) return null;

    const { conferencia, item } = detalhes;
    const { 
        status_conferencia, 
        unidades_check, 
        foto_check, 
        nome_check, 
        codigo_check, 
        marca_check, 
        avaria_check,
        outro_fornecedor_check,
        outro_fornecedor_nome,
        observacao, 
        updated_at 
    } = conferencia;

    const problemas = [
        { label: 'Foto', checked: foto_check },
        { label: 'Nome', checked: nome_check },
        { label: 'Código', checked: codigo_check },
        { label: 'Marca', checked: marca_check },
        { label: 'Avaria', checked: avaria_check },
    ].filter(p => p.checked);

    const statusInfo = {
        1: { color: 'green', icon: <CheckCircleIcon />, text: 'Verificado com Sucesso' },
        2: { color: 'red', icon: <WarningTwoIcon />, text: 'Verificado com Problema' },
        3: { color: 'green', icon: <CheckCircleIcon />, text: 'Verificado - Embalado' },
        4: { color: 'green', icon: <CheckCircleIcon />, text: 'Verificado - Enviado' },
        5: { color: 'green', icon: <CheckCircleIcon />, text: 'Verificado - Liberado com Ressalva' },
    }[status_conferencia] || { color: 'gray', icon: <QuestionOutlineIcon />, text: 'Status Desconhecido' };

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="xl" isCentered>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Detalhes da Conferência</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <VStack spacing={4} align="stretch">
                        <Box textAlign="center">
                            <Badge colorScheme={statusInfo.color} fontSize="lg" p={2} borderRadius="md">
                                {statusInfo.icon} {statusInfo.text}
                            </Badge>
                        </Box>

                        <Divider />

                        <VStack spacing={2} align="stretch">
                            <Heading size="sm" color="gray.600">Resumo</Heading>
                            <Text><strong>Data da Conferência:</strong> {formatDate(updated_at)}</Text>
                            <Text>
                                <strong>Unidades:</strong> {unidades_check ?? 'N/A'} conferidas de {item?.quantidade_esperada ?? 'N/A'} esperadas.
                            </Text>
                        </VStack>

                        {outro_fornecedor_check && (
                            <>
                                <Divider />
                                <VStack spacing={2} align="stretch">
                                    <Heading size="sm" color="blue.600">
                                        <InfoIcon mr={2} />
                                        Outras Informações
                                    </Heading>
                                    <Text>
                                        Produto atendido por <strong>fornecedor alternativo</strong>.
                                        {outro_fornecedor_nome && (
                                            <Badge ml={2} colorScheme="purple">{outro_fornecedor_nome}</Badge>
                                        )}
                                    </Text>
                                </VStack>
                            </>
                        )}

                        {(status_conferencia === 2 && problemas.length > 0) && (
                            <>
                                <Divider />
                                <VStack spacing={2} align="stretch">
                                    <Heading size="sm" color="red.500">Problemas Apontados</Heading>
                                    <List spacing={1}>
                                        {problemas.map(p => (
                                            <ListItem key={p.label}>
                                                <ListIcon as={WarningTwoIcon} color="red.500" />
                                                {p.label}
                                            </ListItem>
                                        ))}
                                    </List>
                                </VStack>
                            </>
                        )}
                        
                        {observacao && (
                           <>
                             <Divider />
                             <VStack spacing={2} align="stretch">
                                <Heading size="sm" color="gray.600">Observações</Heading>
                                <Text p={2} bg="gray.50" borderRadius="md" mt={1} whiteSpace="pre-wrap">{observacao}</Text>
                             </VStack>
                           </>
                        )}
                    </VStack>
                </ModalBody>
                <ModalFooter>
                    <Button colorScheme="blue" onClick={onClose}>Fechar</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};